import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import { selectAuth } from "../../components/auth/auth.selector";
import LMSClosureStructure from "../../components/lead-management/lms-closure-report/LMSClosureStructure";

const LMSClosureReport = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return (
    <HelmetWrapper title="WTF: Lead Management System">
      <Container className="bg-cloud-k px-50px" fluid>
        <LMSClosureStructure userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default LMSClosureReport;
